import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import ProgressBar from "../ProgressBar";
import ProgramSidebar from "../sidebar/ProgramSidebar";
import ProgressBox from "../sidebar/ProgressBox";
import BioBox from "../sidebar/BioBox";

const StyledCourseSectionGrid = styled.div`
  display: grid;
  grid-template-columns: auto 340px;
  grid-column-gap: 2rem;

  @media (max-width: 1060px) {
    display: block;
    .courseSections {
      margin-bottom: 2rem;
    }
  }
  .courseSections {
    display: grid;
    grid-template-rows: auto;
    grid-row-gap: 2rem;
    box-shadow: ${(props) => props.theme.boxShadow};
    a {
      text-decoration: none;
      color: black;
    }
    .sectionRow {
      display: grid;
      grid-template-columns: 125px auto 100px;
      grid-column-gap: 2rem;
      align-items: center;
      img {
        width: 100%;
      }
      @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
        display: block;
        .sectionTitle {
          margin: 10px auto;
        }
      }
    }
  }
`;

const CourseSectionGrid = ({
  programData,
  completedTokens,
  totalLessonsArray,
  currentPath,
}) => {
  // Completed of total course
  const totalCompleted = totalLessonsArray.filter(
    (lesson) => completedTokens.indexOf(lesson.programPostId) > -1
  );

  // Completed of each section
  return (
    <StyledCourseSectionGrid>
      <div>
        <div className="courseSections whiteBG innerPadding">
          {/* <h3>Transform Into A Fulfilled Greek Conqueror</h3> */}
          {programData.map((mainCategory) => {
            const categoryIds = totalLessonsArray.filter(
              (lesson) => lesson.mainCategoryId === mainCategory.mainCategoryId
            );
            const catgeoryCompletedIds = categoryIds.filter(
              (lesson) => completedTokens.indexOf(lesson.programPostId) > -1
            );
            return (
              <Link
                to={`${currentPath}/section/${mainCategory.mainCategoryId}`}
                key={mainCategory.mainCategoryId}
              >
                <div className="sectionRow">
                  <img
                    src={`${mainCategory.mainCategoryImage}?fm=jpg&w=250`}
                    alt=""
                  />
                  <h4 className="sectionTitle">
                    {mainCategory.mainCategoryTitle}
                  </h4>
                  <ProgressBar
                    percentageComplete={
                      catgeoryCompletedIds.length / categoryIds.length
                    }
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
      <ProgramSidebar>
        <ProgressBox
          completed={totalCompleted.length}
          total={totalLessonsArray.length}
        />
        <BioBox />
      </ProgramSidebar>
    </StyledCourseSectionGrid>
  );
};

export default CourseSectionGrid;
